import { units } from "@/internal/types";
import { useLemonadeContext } from "@/LemonadeProvider";

type UnitOptionsProps = {
    ingredient: string;
};

export function UnitOptions({ ingredient }: Readonly<UnitOptionsProps>) {
    const { getUnitsForIngredient } = useLemonadeContext();
    return (
        <>
            {units
                .filter((u) => getUnitsForIngredient(ingredient).includes(u))
                .map((unit) => (
                    <option key={unit} value={unit}>
                        {unit}
                    </option>
                ))}
        </>
    );
}
